/*
 * Stamps stable anchor ids (#toc-1, #toc-2, ...) onto the article's H2s so the
 * server-rendered Table of Contents links in sections/main-article.liquid scroll
 * to the matching heading.
 *
 * Setting an id on an element that already exists in the DOM does NOT change its
 * box, so this runs with zero Cumulative Layout Shift. The previous version of
 * this file built the <ul> (or removed the whole TOC) on DOMContentLoaded, which
 * grew/collapsed the TOC box after first paint and shifted the article on every
 * post (GSC "CLS issue: more than 0.1 (desktop)", 198 blog URLs).
 *
 * The ids are index-based and assigned in document order, matching the
 * forloop.index used to build the #toc-N hrefs in Liquid. This avoids the
 * accent/slug mismatch the old text-based id generator had on French headings.
 */
function addTableOfContentsAnchors() {
  const prose = document.querySelector('.article-main .prose');

  if (!prose) {
    return;
  }

  prose.querySelectorAll('h2').forEach((heading, index) => {
    heading.id = 'toc-' + (index + 1);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addTableOfContentsAnchors);
} else {
  addTableOfContentsAnchors();
}
